/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findDerivedReminderRecsSF = (queryName = 'DerivedReminderRecommendations') => (
    gql`query ${queryName}(
      $brand: String!,
      $environment: String!,
      $targeting: TargetingSF!
      $user: UserSF!
      $isHoldoutEligible: Boolean!
      $resolveIdentity: Boolean!
      $windowingWeeks: Int!,
      $maxCarousels: Int!,
    ) {
      derivedReminderRecs(
        brand: $brand,
        environment: $environment,
        targeting: $targeting,
        user: $user,
        isHoldoutEligible: $isHoldoutEligible
        resolveIdentity: $resolveIdentity
        windowingWeeks: $windowingWeeks
        maxCarousels: $maxCarousels
    ) {
      campaign
      recipients {
        name
        occasion
        dynamicHeader
        product {
          partNumber
          name
          isPassportEligible
          image {
            name
            path
          }
          seo {
            url
          }
          skuPriceRange {
            retail {
              value
            }
            sale {
              value
            }
          }
          productSkus {
            partNumber
            name
          }
          productType,
          productDeliveryType,
        }
        productRecs {
          partNumber
          name
          isPassportEligible
          image {
            name
            path
          }
          seo {
            url
          }
          skuPriceRange {
            retail {
              value
            }
            sale {
              value
            }
          }
          productSkus {
            partNumber
            name
          }
          productType,
          productDeliveryType,
        }
      }
      productsContent
      isHoldout
      recipCount
    }
    }
  `
);

export default findDerivedReminderRecsSF;
